// 保留时分时间过滤
const timeFilter = x => {
  if (x) {
    let time1 = x.split('T')[0];
    let time2 = x.split('T')[1];
    let time3 = time2.split(':')[0];
    let time4 = time2.split(':')[1];
    let timeFilter = time1 + ' ' + time3 + ':' + time4
    return timeFilter
  }
}
// 保留时间到天
const timeFilterData = x => {
  if (x) {
    let time1 = x.split('T')[0];
    let timeFilterData = time1
    return timeFilterData
  }
}

const isInSupplyerList = (supId) => {
  return [1, 749, 750, 769, 642, 603, 693, 663, 665, 670, 664, 59, 490, 464, 229, 235, 605, 731, 618, 610, 638, 555, 556, 631, 450].includes(supId)
}

const activeName = x => {
  var obj = {
    0: '无',
    1: '开新一刻',
    2: '营客通推荐',
    3: '囤货专区',
    4: '直播',
    5: '专属购',
    6: '渠道购',
    7: '新人专享',
    8: '下单立减',
    9: '每日特价',
    10: '通用活动',
    11: '分享好货',
    12: '老用户专享',
    13: '高毛利专区',
    14: '营客通巨惠',
    15: 'C端主题活动',
    16: 'C端新人活动',
    17: '赠品',
    18: '满减',
    19: 'C-营客通优选',
    20: '寻货',
    21: '订货会',
    22: 'C-买赠',
    23: '平台渠道商',
    24: '商家邀请商家',
    25: '每日精选',
    26: '秒杀活动',
    27: '多件折扣',
    28: '活动品牌推荐',
    29: '预售活动',
    30: '营客通'
  }
  return obj[x]
}

const CannelActiveName = x => {
  if (x == 0) {
    return '无'
  } else if (x == 1) {
    return '秒杀活动'
  } else if (x == 2) {
    return '囤货活动'
  } else if (x == 3) {
    return '满额立减'
  }
}

const orderStatusName = x => {
  if (x == 10) {
    return '待支付'
  } else if (x == 20) {
    return '备货中'
  } else if (x == 30) {
    return '待收货'
  } else if (x == 40) {
    return '已收货'
  } else if (x == 50) {
    return '已完成'
  } else if (x == 60) {
    return '已取消'
  } else if (x == 70) {
    return '已关闭'
  }
}
// 处理金额
function fmoney(s) {   
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";  
  var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];  
  var t = "";  
  for (var i = 0; i < l.length; i++) {  
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");  
  }  
  return t.split("").reverse().join("") + "." + r;  
}
 function daojishi(mistiming) {
  if (mistiming > 0) {
    var days = Math.floor(mistiming / 1000 / 60 / 60 / 24) // 获取天数
    var hours = Math.floor(mistiming / 1000 / 60 / 60 % 24) // 获取小时
    var minutes = Math.floor(mistiming / 1000 / 60 % 60) // 获取分钟数
    var seconds = Math.floor(mistiming / 1000 % 60) // 获取秒数

    // 判断天、时、分、秒是不是两位数，如果是直接输出，如果不是在前边加个0;
    days < 10 ? days = '0' + days : days
    hours < 10 ? hours = '0' + hours : hours
    minutes < 10 ? minutes = '0' + minutes : minutes
    seconds < 10 ? seconds = '0' + seconds : seconds

    // 第一种连接方法
    // var rels = days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
    // 第二种连接方法
    var rels = `${hours}:${minutes}:${seconds}`
  }
  // 判断时间差是不是正数，就是截止时间是不是比现在的时间晚
  var mis = mistiming > 0 ? rels : '已超时'
  return mis
}
export {
  activeName,
  timeFilter,
  timeFilterData,
  fmoney,
  CannelActiveName,
  orderStatusName,
  daojishi
}